import React from 'react';
import { Typography } from '@mui/material';
import VariableTextField from '../../VariableTextField';
import { FlowComponent } from '../../../../flow-core/FlowComponent';
import { TextCaptionCore } from '../../../../flow-core/components/TextCaptionCore';

export const TextCaptionComponent = new FlowComponent({
  ...TextCaptionCore,
  renderPreview(properties) {
    return (
      // Match WhatsApp's TextCaption: ~13px secondary grey, MUI caption (12px) ran small.
      <Typography
        display="block"
        gutterBottom
        sx={{ fontSize: '0.8125rem', color: 'text.secondary', lineHeight: 1.4 }}
      >
        {properties.text || 'Caption text'}
      </Typography>
    );
  },
  renderPropertyEditor(properties, onChange, context) {
    return (
      <VariableTextField
        fullWidth
        label="Text"
        value={properties.text || ''}
        onChange={(e) => onChange('text', e.target.value)}
        required
        multiline
        rows={2}
        inputProps={{ maxLength: 4096 }}
        helperText={`${(properties.text || '').length}/4096 characters, use {x} to insert field references`}
        size="small"
        screens={context?.screens}
        currentScreenId={context?.currentScreenId}
      />
    );
  },
});
